import { gql } from '@apollo/client'

import { WebhookSubscriptionDetailsFragment } from 'graphql/fragments'

export const CREATE_WEBHOOK_SUBSCRIPTION = gql`
  mutation createWebhookSubscription($input: CreateWebhookSubscriptionDtoInput!) {
    createWebhookSubscription(input: $input) {
      ...WebhookSubscriptionDetails
    }
  }

  ${WebhookSubscriptionDetailsFragment}
`

export const UPDATE_WEBHOOK_SUBSCRIPTION = gql`
  mutation updateWebhookSubscription($input: UpdateWebhookSubscriptionDtoInput!) {
    updateWebhookSubscription(input: $input) {
      ...WebhookSubscriptionDetails
    }
  }

  ${WebhookSubscriptionDetailsFragment}
`

export const SET_WEBHOOK_SUBSCRIPTION_ENABLED = gql`
  mutation setWebhookSubscriptionEnabled($webhookSubscriptionId: Long!, $isEnabled: Boolean!) {
    setWebhookSubscriptionEnabled(
      webhookSubscriptionId: $webhookSubscriptionId
      isEnabled: $isEnabled
    ) {
      ...WebhookSubscriptionDetails
    }
  }

  ${WebhookSubscriptionDetailsFragment}
`
